"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCoverageDefinitionList = exports.LineOfCoverageDefinitionList = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var react_1 = __importDefault(require("react"));
var render_policy_name_1 = __importDefault(require("../../utils/render-policy-name"));
function LineOfCoverageDefinitionList(props) {
    var lineOfCoverage = props.lineOfCoverage;
    return react_1.default.createElement(core_ui_1.DefinitionList, { items: createCoverageDefinitionList(lineOfCoverage), labelWidth: "150px" });
}
exports.LineOfCoverageDefinitionList = LineOfCoverageDefinitionList;
function createCoverageDefinitionList(lineOfCoverage) {
    var _a;
    var startDate = lineOfCoverage.startDate, endDate = lineOfCoverage.endDate;
    var _b = lineOfCoverage.policy, policyNumber = _b.policyNumber, displayName = _b.details.displayName, definition = _b.definition, type = _b.type;
    var items = [
        {
            type: 'document',
            title: 'Policy',
            value: render_policy_name_1.default((_a = definition === null || definition === void 0 ? void 0 : definition.readableName) !== null && _a !== void 0 ? _a : type, displayName),
        },
        {
            type: 'number',
            title: 'Policy number',
            value: policyNumber,
            href: '#',
        },
    ];
    if (startDate && !endDate) {
        items.push({
            type: 'dateRange',
            title: 'Effective date',
            value: "" + string_formatters_1.CalendarDate.fromDate(startDate, 'UTC'),
        });
    }
    if (!startDate && endDate) {
        items.push({
            type: 'dateRange',
            title: 'Expiration date',
            value: "" + string_formatters_1.CalendarDate.fromDate(endDate, 'UTC'),
        });
    }
    if (startDate && endDate) {
        items.push({
            type: 'dateRange',
            title: 'Effective dates',
            value: string_formatters_1.CalendarDate.fromDate(startDate, 'UTC') + " - " + string_formatters_1.CalendarDate.fromDate(endDate, 'UTC'),
        });
    }
    return items;
}
exports.createCoverageDefinitionList = createCoverageDefinitionList;
